(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    var stickyAtc    = document.getElementById('sticky-atc');
    var stickyBtn    = document.getElementById('sticky-atc-btn');
    var mainForm     = document.querySelector('.pdp-form');
    var mainSubmit   = mainForm ? mainForm.querySelector('[type="submit"]') : null;

    if (!stickyAtc || !mainSubmit) return;

    /* Show/hide based on main ATC visibility */
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting && window.scrollY > 200) {
          stickyAtc.classList.add('active');
          stickyAtc.setAttribute('aria-hidden', 'false');
        } else {
          stickyAtc.classList.remove('active');
          stickyAtc.setAttribute('aria-hidden', 'true');
        }
      });
    }, { threshold: 0 });

    observer.observe(mainSubmit);

    /* AJAX Add to Cart via sticky button */
    if (stickyBtn && mainForm) {
      stickyBtn.addEventListener('click', function() {
        stickyBtn.textContent = 'Adding…';
        stickyBtn.disabled = true;

        var idInput  = mainForm.querySelector('[name="id"]');
        var qtyInput = mainForm.querySelector('[name="quantity"]');
        var id  = idInput  ? parseInt(idInput.value)  : null;
        var qty = qtyInput ? parseInt(qtyInput.value) : 1;

        if (!id) { stickyBtn.textContent = 'Add to Cart'; stickyBtn.disabled = false; return; }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: id, quantity: qty })
        })
        .then(function(r) {
          if (!r.ok) return r.json().then(function(e){ throw new Error(e.description || 'Could not add'); });
          return r.json();
        })
        .then(function() {
          stickyBtn.textContent = 'Added!';
          if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
          setTimeout(function() {
            stickyBtn.textContent = 'Add to Cart';
            stickyBtn.disabled = false;
          }, 1200);
        })
        .catch(function(err) {
          stickyBtn.textContent = err.message || 'Error';
          stickyBtn.disabled = false;
        });
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
